import { Identifiable, ProjectStatus } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = {
  _embedded: {
    projectStatuses: Identifiable<ProjectStatus>[];
  };
};

function getProjectStatuses(httpClient: HttpClient) {
  return (): Promise<Identifiable<ProjectStatus>[]> =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: "/projectStatuses",
        method: HttpMethods.GET,
      })
      .then(({ _embedded }) => _embedded.projectStatuses);
}

export { getProjectStatuses };
